var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"fill-height side-panel pa-0 ma-0 mt-auto elevation-5"},[_c('div',{staticClass:"panel-wrapper"},[_c('div',{staticClass:"panel-title"},[_vm._t("title")],2),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }